import axiosApi from '../api/axiosApi';

class ConfigPropApi {
    static setConfigProps(configProps) {
        return axiosApi.post('ConfigProp', false, configProps).then(response => {
            return response;
        }).catch(error => {
            throw error;
        });
    }
}

export default ConfigPropApi;  